var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrigin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 15.587C4 10.9423 6.63882 6.91397 10.499 4.91935L15.5382 1L14.8919 3.63751C15.2568 3.6041 15.6264 3.58703 16 3.58703C22.6274 3.58703 28 8.95961 28 15.587C28 19.979 25.6405 23.8199 22.12 25.9113L16.0017 31.0887L17.2027 27.5275C16.8071 27.5669 16.4059 27.587 16 27.587C9.37258 27.587 4 22.2144 4 15.587ZM16.0001 20.9205C18.9456 20.9205 21.3335 18.5327 21.3335 15.5872C21.3335 12.6416 18.9456 10.2538 16.0001 10.2538C13.0546 10.2538 10.6668 12.6416 10.6668 15.5872C10.6668 18.5327 13.0546 20.9205 16.0001 20.9205Z",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrigin);
export default __webpack_public_path__ + "static/media/origin.91b5432253962be5213f3e9f25ecffd3.svg";
export { ForwardRef as ReactComponent };